import { useZoomFromQueryParams } from 'hooks/useZoomFromQueryParams';
import { useMapState } from 'state/useMapState';

// Falls back to the map's last zoom so navigating from a detail view into an edit form keeps the zoom level the same
export const useInitialMapZoom = (zoomOverride?: number): number => {
  const zoomFromQueryParams = useZoomFromQueryParams();
  const { incidentMapState } = useMapState();

  return zoomOverride ?? zoomFromQueryParams ?? incidentMapState.zoom;
};
